import React, { Component } from 'react'
import { BrowserRouter, Route, Redirect, Switch } from 'react-router-dom'
import PropTypes from 'prop-types'
import Dashboard from './Dashboard'
import Login from './Login'
import AddPractice from './AddPractice'
import TopMenu from './TopMenu'
import authManager from './services/auth'
import css from './App.css'
import { newPracticeStorage, userStorage } from './services/localStorage'
import { downloadStats, searchPractices } from './common/requests'
import Socket from './Socket'
import { clearPracticeStatsData, clearRecents } from './services/practiceStorage'

class App extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
  }
  state = {
    newPracticeId: newPracticeStorage.get(),
    isTopsAdmin: userStorage.get() && userStorage.get().includes('tops_'),
    isSuperAdmin:
      userStorage.get() && userStorage.get().includes('super_admin'),
    downloading: false,
    practicesLoading: false,
    recentPracticesLoading: false,
    searchFilters: {
      searchString: '',
      products: [],
      pmsTypes: [],
      activeOnly: false,
    },
  }
  // pass this function to all components that may get an unauthorized error and call it as needed
  onSignout = () => {
    authManager.signout()
    clearRecents()
    clearPracticeStatsData()
    this.props.history.push('/')
  }

  handleNavClicks = ({ key }) => {
    switch (key) {
      case 'signout':
        this.onSignout()
        break
      case 'add-practice':
        this.setState({
          newPracticeId: null,
        })
        newPracticeStorage.clear()
        break
      case 'download':
        if (this.state.downloading) {
          break
        }
        this.setState({
          downloading: true,
        })
        downloadStats().then((response) => {
          this.downloadFile(response.data)
          this.setState({
            downloading: false,
          })
        })
        break
      default:
        break
    }
  }

  updateSearchString = (searchString) => {
    const { searchFilters } = this.state
    this.setState(
      {
        searchFilters: {
          ...searchFilters,
          searchString,
        },
      },
      this.debounce(() => this.searchPractices(), 750),
    )
  }

  updateProducts = (products) => {
    const { searchFilters } = this.state
    this.setState(
      {
        searchFilters: {
          ...searchFilters,
          products,
        },
      },
      this.searchPractices,
    )
  }

  updatePmsTypes = (pmsTypes) => {
    const { searchFilters } = this.state
    this.setState(
      {
        searchFilters: {
          ...searchFilters,
          pmsTypes,
        },
      },
      this.searchPractices,
    )
  }

  updateActiveOnly = (activeOnly) => {
    const { searchFilters } = this.state
    this.setState(
      {
        searchFilters: {
          ...searchFilters,
          activeOnly,
        },
      },
      this.searchPractices,
    )
  }

  searchPractices = () => {
    this.toggleLoading(true)
    searchPractices(this.state.searchFilters)
  }

  debounce(funcToDelay, delayByTime) {
    clearTimeout(this.onChangeTimeout)
    this.onChangeTimeout = setTimeout(funcToDelay, delayByTime)
  }

  toggleLoading = (loading) => {
    this.setState({ practicesLoading: loading })
  }

  toggleRecentsLoading = (loading) => {
    this.setState({ recentPracticesLoading: loading })
  }

  downloadFile = (data) => {
    const url = window.URL.createObjectURL(new Blob([data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', 'practice_data.csv')
    document.body.appendChild(link)
    link.click()
  }

  savePracticeId = (practiceId) => {
    this.setState({
      newPracticeId: `${practiceId}`,
    })
    newPracticeStorage.set(practiceId)
  }

  editPractice = (practiceId) => {
    this.savePracticeId(practiceId)
    this.props.history.push('/add-practice')
  }

  render() {
    const {
      newPracticeId,
      isTopsAdmin,
      isSuperAdmin,
      downloading,
      practicesLoading,
      recentPracticesLoading,
      searchFilters,
    } = this.state
    const { location } = this.props
    return (
      <div className={css.app}>
        <TopMenu
          location={location}
          onClick={this.handleNavClicks}
          isSuperAdmin={isSuperAdmin}
          isTopsAdmin={isTopsAdmin}
          downloading={downloading}
        />
        <div className={css.main}>
          <Switch>
            <Route
              path="/dashboard"
              render={props => (
                <Dashboard
                  {...props}
                  loading={practicesLoading}
                  recentsLoading={recentPracticesLoading}
                  toggleLoading={this.toggleLoading}
                  toggleRecentsLoading={this.toggleRecentsLoading}
                  signout={this.onSignout}
                  editPractice={this.editPractice}
                  isTopsAdmin={isTopsAdmin}
                  updateSearchString={this.updateSearchString}
                  updateProducts={this.updateProducts}
                  updatePmsTypes={this.updatePmsTypes}
                  updateActiveOnly={this.updateActiveOnly}
                  searchFilters={searchFilters}
                  searchPractices={this.searchPractices}
                />
              )}
            />
            <Route
              path="/add-practice"
              render={props => (
                <AddPractice
                  {...props}
                  signout={this.onSignout}
                  isTopsAdmin={isTopsAdmin}
                  practiceId={newPracticeId}
                  savePracticeId={this.savePracticeId}
                />
              )}
            />
            <Redirect to="/dashboard" />
          </Switch>
        </div>
        <Socket
          channelName="DashboardChannel"
          toggleLoading={this.toggleLoading}
          toggleRecentsLoading={this.toggleRecentsLoading}
        />
      </div>
    )
  }
}

export default () => (
  <BrowserRouter>
    <Switch>
      <Route path="/login" component={Login} />
      <Route
        path="/"
        render={props => (
        authManager.isAuthenticated ? (
          <App {...props} />
        ) : (
          <Redirect to="/login" />
        ))
      }
      />
    </Switch>
  </BrowserRouter>
)



// WEBPACK FOOTER //
// ./src/App.js